import { ConfigInterface, responseInterface } from 'swr';
import { api, parseUrl, useApi } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';
import { Product } from '@gik/core/models/gik/Product';
import { apiCap } from '..';

const path = 'products';

function getParams(categoryId?: number) {
  return {
    giftCardCategoryId: categoryId === undefined || categoryId === 0 ? undefined : categoryId,
    checkoutTypes: categoryId === undefined || categoryId === 0 ? 'tango-card' : undefined,
    per_page: apiCap,
  };
}

export function getGiftcardProductsByCategoryId(categoryId?: number): ResponsePromise {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(categoryId),
  });

  return api.get(finalUrl);
}

export function useGiftcardProductsByCategoryId<Data = Product[], Error = WordpressError>(
  categoryId?: number,
  config?: ConfigInterface
): responseInterface<Data, Error> {
  return useApi<Data, Error>(path, config, {
    searchParams: getParams(categoryId),
  });
}
